var _path, _ellipse;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_37033",
    "data-name": "Group 37033",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.398,
    height: 12.043,
    viewBox: "0 0 17.398 12.043",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M11.7,19.041a9.192,9.192,0,0,0,8.657-5.787.669.669,0,0,0,0-.468A9.192,9.192,0,0,0,11.7,7a9.192,9.192,0,0,0-8.657,5.787.669.669,0,0,0,0,.468A9.192,9.192,0,0,0,11.7,19.041ZM19,13.021A7.874,7.874,0,0,1,11.7,17.7,7.874,7.874,0,0,1,4.39,13.021,7.874,7.874,0,0,1,11.7,8.338,7.874,7.874,0,0,1,19,13.021Z",
    transform: "translate(-2.997 -6.999)",
    fill: "#39be9d"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_134",
    "data-name": "Ellipse 134",
    cx: 3.169,
    cy: 3.169,
    rx: 3.169,
    ry: 3.169,
    transform: "translate(5.531 2.679)",
    fill: "#39be9d"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.90052ee3a368c9a9eb0ea5ce69521fd6.svg";
export { ForwardRef as ReactComponent };